export const SALE_CONFIG = {
    requests: {
        getStockItem: {
            url: `sale/items`,
        },
        getStockDiscardItem: {
            url: `discard-seed/balance`,
        },
        getReserveCustomer: {
            url: `sale/customers`,
        },
        saleDoi: {
            url: `sale/dois`,
        },
        promotion: {
            url: `sale/promotion-prices`,
        }
    },
};
